import React from 'react'

import { Box } from '@mui/material'

import PrimaryLayout from '../components/layout/PrimaryLayout'

const Dashboard: React.FC = () => {

    return (
        <PrimaryLayout>
            <Box height='calc(100vh - 50px)'>
                <iframe
                    src={process.env.REACT_APP_GRAFANA_URL + '/d/centurion-dashboard?orgId=1&kiosk=1&theme=light'}
                    width="100%"
                    height="100%"
                    title="Dashboard"
                ></iframe>
            </Box>
        </PrimaryLayout>
    )
}

export default Dashboard